import { render } from "./ChildrenSummary.vue?vue&type=template&id=0188e48b&scoped=true"
import script from "./ChildrenSummary.vue?vue&type=script&lang=js"
export * from "./ChildrenSummary.vue?vue&type=script&lang=js"

import "./ChildrenSummary.vue?vue&type=style&index=0&id=0188e48b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0188e48b"]])

export default __exports__